interface ErrorAlertProps {
  error: string | null;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ error }) => {
  if (!!error)
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  return null;
};
export default ErrorAlert;
